import { type RootContainerProps } from "@client/content/types";
import { connectCustom } from "@client/lib/misc";
import { TargetSelector, getCompositeSettingSelector } from "@client/selectors";
import { type AppState } from "@client/types/AppState";
import { type Action, type Dispatch } from "redux";
import { goToStep } from "../actions";
import { localStateSelector, makePreloaderStepsSelector } from "../selectors";
import Component, {
  type Preloader,
  type PurchaseModalThirdComponentActionProps,
  type PurchaseModalThirdComponentMapProps
} from "./component";

const makeMapStateToProps = () => {
  const preloaderSelector = getCompositeSettingSelector<Preloader>(TargetSelector.Entity, "preloader");
  const stepsSelector = makePreloaderStepsSelector();

  return (state: AppState, props: RootContainerProps): PurchaseModalThirdComponentMapProps => {
    const localState = localStateSelector(state, props);

    return {
      canClose: localState.step !== 3 || !!localState.error,
      error: localState.error,
      isEditMode: state.isEditMode,
      isInProgress: localState.isSettingUp,
      isVisible: localState.step === 3,
      preloader: preloaderSelector(state, props)!,
      redirectUrl: localState.redirectUrl,
      steps: stepsSelector(state, props)
    };
  };
};

const mapDispatchToProps = (
  dispatch: Dispatch<Action>,
  props: RootContainerProps
): PurchaseModalThirdComponentActionProps => ({
  onClose: () => dispatch(goToStep(props, 1))
});

export default connectCustom(makeMapStateToProps, mapDispatchToProps)(Component);
